var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window-item',{key:_vm.name,attrs:{"value":_vm.value}},[_c('div',{staticClass:"left-tab__panel"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }